import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { MenuNavigationService } from 'app/services/menu-navigation.service';
import { APP_CONSTANTS } from 'app/app.constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule, IonicModule, SideMenuComponent],
  standalone:true
})
export class HeaderComponent  {
  @Input() title = '';
  @Input() subTitle = '';

  constructor(
    protected menuNavigationService: MenuNavigationService
  ) { }

  public goToHome() {
    this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.HOME);
    this.menuNavigationService.resetData();
  }
}
